import React from "react";
import { fold } from "../lib/asciiFolder";

function useFilteredOptions<T>(options: T[], extractFilterKey?: (option: T) => string) {
  const [filter, setFilter] = React.useState("");

  const filterChunks = React.useMemo(
    () =>
      fold(filter)
        .toLowerCase()
        .split(/[^A-Za-z0-9]/),
    [filter],
  );

  const optionTexts = React.useMemo(
    () => (extractFilterKey ? options.map(o => fold(extractFilterKey(o)).toLowerCase()) : []),
    [extractFilterKey, options],
  );

  const filteredOptions = React.useMemo(
    () =>
      extractFilterKey
        ? options.filter((_, index) =>
            filterChunks.every(chunk => optionTexts[index]?.includes(chunk)),
          )
        : options,
    [extractFilterKey, filterChunks, optionTexts, options],
  );

  return { filteredOptions, filter, setFilter };
}

export default useFilteredOptions;
